import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import {
	AUTH_PREFIX_PATH,
	UNAUTHENTICATED_ENTRY,
	REDIRECT_URL_KEY,
	APP_PREFIX_PATH
} from 'configs/AppConfig'
import userService from 'services/UserService'

const ProtectedRoute = () => {

	const { token } = useSelector(state => state.auth)
	const location = useLocation()

	if (!token) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	// STAFF users only have access to the staff dashboard, guest check-in and password change
	const roles = userService.getCurrentUserRoles();
	const isStaff = roles.includes('STAFF') && !roles.includes('ADMIN') && !roles.includes('NOIVX');
	if (isStaff) {
		const staffAllowedPaths = [
			`${APP_PREFIX_PATH}/staff-dashboard`,
			`${APP_PREFIX_PATH}/check-in`,
			`${APP_PREFIX_PATH}/alterar-senha`
		];
		if (!staffAllowedPaths.includes(location.pathname)) {
			return <Navigate to={`${APP_PREFIX_PATH}/staff-dashboard`} replace />;
		}
	}

	return <Outlet />
}

export default ProtectedRoute